import { MaybeUndef } from 'types/UtilityTypes';

type AutoVehicleLabelParts = {
  year?: MaybeUndef<string | number>;
  make?: MaybeUndef<string>;
  model?: MaybeUndef<string>;
};

// "2020 Toyota Camry". Skips whichever of year, make, and model is missing.
export function formatAutoVehicleLabel(parts: AutoVehicleLabelParts): string {
  return [parts.year, parts.make, parts.model]
    .filter((part) => part != null && String(part).trim() !== '')
    .map((part) => String(part).trim())
    .join(' ');
}
